import { c as _c } from "react/compiler-runtime";
import React from "react";
import { SingleWaveDropTab } from "./SingleWaveDrop";
import { SingleWaveDropTabs } from "./SingleWaveDropTabs";
import { SingleWaveDropClose } from "./SingleWaveDropClose";
interface SingleWaveDropHeaderProps {
  readonly activeTab: SingleWaveDropTab;
  readonly setActiveTab: (tab: SingleWaveDropTab) => void;
  readonly onClose: () => void;
}
export const SingleWaveDropHeader: React.FC<SingleWaveDropHeaderProps> = t0 => {
  const $ = _c(8);
  const {
    activeTab,
    setActiveTab,
    onClose
  } = t0;
  let t1;
  if ($[0] !== activeTab || $[1] !== setActiveTab) {
    t1 = <SingleWaveDropTabs activeTab={activeTab} setActiveTab={setActiveTab} />;
    $[0] = activeTab;
    $[1] = setActiveTab;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onClose) {
    t2 = <SingleWaveDropClose onClose={onClose} />;
    $[3] = onClose;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="lg:tw-hidden tw-inline-flex tw-w-full tw-justify-between tw-items-center tw-relative tw-px-4 tw-pt-[env(safe-area-inset-top,0px)] tw-gap-3">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};